module.exports = __webpack_public_path__ + "static/about_detale-66daad62a705dcb40d5c8eafae6a1b47.jpg";